import React from 'react';
import {CircularProgress, Typography} from "@mui/material";

export function CenteredCircularProgress(props: { loadingText?: string }) {

  return (
    <div style={{height: "100vh"}} className={"container"}>
      <div className={"content"}>
        <CircularProgress className={"circular-progress"}/>
        {
          props.loadingText &&
          <Typography variant={"subtitle2"}
                      className={props.loadingText ? "typography" : "typography-hidden"}>{props.loadingText}</Typography>
        }
      </div>
    </div>
  )

}
